const YEN_MAN = 10000;

/** 1 坪 = 3.305785 ㎡ (バックエンド reinfolib.py の坪換算と同じ定数)。 */
export const TSUBO_M2 = 3.305785;

export function formatYen(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '--';
  if (value >= YEN_MAN * 10000) {
    return `${(value / (YEN_MAN * 10000)).toFixed(1)}億円`;
  }
  if (value >= YEN_MAN) {
    return `${Math.round(value / YEN_MAN).toLocaleString('ja-JP')}万円`;
  }
  return `${value.toLocaleString('ja-JP')}円`;
}

// ㎡ 単価 (円/㎡) の表示。formatYen は 1万円以上を整数の万円に丸めるが、㎡ 単価は坪単価の 1/3.3 で
// 郊外の大半が 1万〜10万円/㎡ 帯に入り、整数丸めだと誤差が最大 ±33% になるため、この帯は小数1桁で出す。
// 坪→㎡ の換算で生じる円未満の端数は元データに無い精度なので、先に円へ丸める。
export function formatYenPerM2(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '--';
  const yen = Math.round(value);
  if (yen >= YEN_MAN && yen < YEN_MAN * 10) {
    return `${(yen / YEN_MAN).toFixed(1)}万円/㎡`;
  }
  return `${formatYen(yen)}/㎡`;
}

export function formatDistanceM(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '--';
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)} km`;
  }
  return `約 ${Math.round(value)} m`;
}

export function formatWalkMinutes(meters: number | null | undefined): string {
  if (meters == null || !Number.isFinite(meters)) return '--';
  return `徒歩 約 ${Math.max(1, Math.ceil(meters / 80))} 分`;
}

export function formatLatLng(lat: number, lon: number): string {
  return `${lat.toFixed(5)}, ${lon.toFixed(5)}`;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '--';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '--';
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
}

export function formatIssueNumber(iso: string | null | undefined): string {
  if (!iso) return '----';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '----';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}${day}`;
}

export function splitAddress(address: string | null | undefined): {
  pref: string;
  name: string;
} {
  if (!address) return { pref: '', name: '' };
  const match = address.match(/^(.+?[都道府県])(.*)$/);
  if (match) {
    return { pref: match[1] ?? '', name: (match[2] ?? '').trim() };
  }
  return { pref: '', name: address };
}
